<template>
  <div class="wrap1 flex-row">
    <!-- <div></div> -->
    <div class="wrap2 flex-col">
      <div class="layer1 flex-row justify-between">
        <div
          class="title flex-col"
          style="
            background-image: url(/static/img/login-bg.png);
            width: 10rem;
            height: 2.4rem;
            line-height: 2.4rem;
            background-repeat: no-repeat;
            text-align: center;
            background-position: center center;
            background-size: 60% 100%;
            font-size: 1.2rem;
          "
        >
          {{ type == 3 ? "微信登録/注册" : "登録/注册" }}
        </div>
        <div
          style="
            width: 10rem;
            height: 2.4rem;
            line-height: 2.4rem;
            background-repeat: no-repeat;
            text-align: center;
            background-position: center center;
            background-size: 60% 100%;
            font-size: 1.2rem;
            cursor: pointer;
            color: #4473d0;
          "
          @click="gotoDaoke"
        >
          稻壳登录
        </div>
        <!-- <div v-if="type != 3" class="wxbc"><p>微信登録更快捷</p></div> -->
        <!-- <div class="outer2 flex-col" @click="weixinLogin">
          <img
            class="label1"
            style="cursor: pointer"
            referrerpolicy="no-referrer"
            :src="type == 3 ? './static/computer.png' : './static/code.png'"
          />
        </div> -->
      </div>
      <div v-if="type === 1" class="layer2 flex-row">
        <el-input placeholder="請輸入賬號"></el-input>
      </div>
      <div v-if="type === 1" class="layer3 flex-row">
        <el-input show-password placeholder="請輸入密碼"></el-input>
      </div>

      <div v-if="type === 2" class="layer3 flex-col" style="position: relative">
        <el-input
          class="ipt-margin"
          v-model="form.mobile"
          placeholder="請輸入賬號"
        >
          <template slot="prepend">
            <i class="el-icon-user-solid"></i>
<!--            <el-select
              v-model="ac"
              style="margin-left: 10px; border-left: 1px solid #dcdfe6"
              class="ac-ipt"
              size="small"
            >
              <el-option
                v-for="item in codeList"
                :key="item"
                :value="item"
                :label="'+' + item"
              />
            </el-select>-->
          </template>
        </el-input>
        <el-input
          v-model="form.code"
          class="ipt-margin"
          placeholder="請輸入圖片驗證碼"
        >
          <i class="el-icon-coin" slot="prepend"></i>
          <el-button
            slot="append"
            :style="{
              background: `url(${captchaData})`,
              backgroundSize: '100% 100%',
            }"
            @click="getImg"
          ></el-button>
          <!-- <img :src="captchaData" slot="append" @click="getImg" /> -->
        </el-input>

        <!-- <el-input
          v-model="form.smsCode"
          class="ipt-margin"
          placeholder="請輸入短信驗證碼"
        >
          <i class="el-icon-position" slot="prepend"></i>
          <el-button
            style="padding: 0"
            slot="append"
            @click="getSMS"
            :disabled="!!timer"
            :type="!timer ? 'primary' : ''"
            >{{ text }}</el-button
          >
        </el-input> -->
        <el-input
          placeholder="請輸入密碼"
          v-model="form.passWord"
          show-password
        ></el-input>

        <el-input
          v-if="bindchecked"
          v-model="form.cardNo"
          class="ipt-margin"
          placeholder="請输入集團閱讀卡號"
        >
          <i class="el-icon-c-scale-to-original" slot="prepend"></i>
        </el-input>
      </div>
      <div class="layer3 flex-col" v-if="type === 3">
        <wxlogin
          appid="wx4d727c05eff4adac"
          :scope="'snsapi_login'"
          :theme="'black'"
          :redirect_uri="redirectUrl"
        >
        </wxlogin>
        <el-input
          v-if="bindchecked"
          v-model="form.cardNo"
          class="ipt-margin"
          placeholder="請输入集團閱讀卡號"
        >
          <i class="el-icon-c-scale-to-original" slot="prepend"></i>
        </el-input>
      </div>
      <!--      <div class="layer4 flex-row align-center">-->
      <!--        <el-checkbox v-model="bindchecked">綁定集團閲讀卡</el-checkbox>-->
      <!--      </div>-->
      <div class="layer5 flex-row" v-if="type != 3">
        <el-button
          class="login flex-col center"
          type="primary"
          @click="onClick_1"
        >
          登録/注册
        </el-button>
      </div>
      <div class="layer6 flex-row justify-between" v-if="type != 3">
        <el-checkbox class="checked" v-model="checked"
          ><span class="bfore">閲讀并同意</span>使用條款與隱私政策</el-checkbox
        >
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from "@/utils/eventBus.js"
// import VueQr from "vue-qr"
import wxlogin from "@/components/sel-wxlogin"
import {
  read,
  smsCode,
  smsLogin,
  bookInfo,
  bookPage,
  getCaptchaImg,
  getPhoneCode,
  getInfo,
  wxLogin,
  dkLogin
} from "@/api/api"

export default {
  name: "loginBox",
  components: {
    // VueQr,
    wxlogin
  },
  // props: ['loginDialogVisible'],
  data () {
    return {
      // dialogVisible: true,
      // dialogFormVisible: true,//绑定手机号对话框
      // showClose: false,
      // modal: false,
      logoSrc: "",
      text: "獲取驗證碼",
      form: {
        mobile: "",
        smsCode: "1",
        cardNo: "",
        code: "",
        passWord: ""
      },

      ac: "",
      type: 2, //3微信登录
      constants: {},
      checked: true,
      bindchecked: false,
      timer: null,
      captchaData: "",
      codeList: [],
      // redirectUrl: encodeURIComponent('https://www.rulib.cn/#/'),
      redirectUrl: encodeURIComponent(''),
      state: '',
      userinfo: {}
    }
  },
  created () {


    // 微信登录
    eventBus.$on("WeiLogin", (code) => {
      wxLogin({ code: code, cardNo: this.form.cardNo }).then(
        res => {

          if (res.code === 200) {
            localStorage.setItem("token", "Bearer " + res.token)
            eventBus.$emit("getUserInfo")
            // eventBus.$emit("openBindMobile")
            eventBus.$emit("doChangeloginVisible", false)
            this.noparam()
            this.$message.success("登録成功")
            if (this.$route.path == '/login') {
              this.$router.replace({
                path: this.$route.query.forword ? this.$route.query.forword : '/'
              })
            } else if (this.$route.path == '/search') {
              this.$bus.$emit("reloadSearch", true)
            } else {
              location.reload()
            }



          } else {
            this.$message.error(res.msg)
          }
        }
      )

    })
      // 稻壳登录
    const code = new URLSearchParams(window.location.search).get('code');
    console.log(code)
    if(code && (!localStorage.getItem("token"))){
      eventBus.$on("dkLogin", (code) => {
        console.log(3)
        dkLogin({ code: code }).then(
          res => {
            console.log('++++++++++++dkLogin res:', res)
            if (res.code === 200) {
              localStorage.setItem("token", "Bearer " + res.token)
              eventBus.$emit("getUserInfo")
              // eventBus.$emit("openBindMobile")
              eventBus.$emit("doChangeloginVisible", false)
              this.noparam()
              this.$message.success("登録成功")
              if (this.$route.path == '/login') {
                this.$router.replace({
                  path: this.$route.query.forword ? this.$route.query.forword : '/'
                })
              } else if (this.$route.path == '/search') {
                this.$bus.$emit("reloadSearch", true)
              } else {
                location.reload()
              }



            } else {
              this.$message.error(res.msg)
            }
          }
        )

      })
    }

      eventBus.$on("noparam", () => {
        this.noparam()
      })

  },
  mounted () {

    this.logoSrc = require("@/assets/wx.png")
    this.getImg()
    getPhoneCode().then(res => {
      this.codeList = res.data || []
      this.ac = this.codeList[0] || ""
    })
    localStorage.setItem('forword', this.$route.query.forword ? this.$route.query.forword : "/")
    // this.state = parseInt(new Date().getTime() / 100).toString
    // console.log(localStorage.forword)
  },
  methods: {
    gotoDaoke () {
      let redirectUri = encodeURIComponent('http://tlgj.bbtpress.com/')
    /*  let protocol = window.location.protocol
      let redirectHost=protocol+'//'+window.location.host+'/'
      let redirectUri=encodeURIComponent(redirectHost)*/
      window.location.href = `https://tlys.duxiuai.com/oauth2/authorize?response_type=code&client_id=4&redirect_uri=` + redirectUri + `&scope=userinfo,unionid&clientSecret=2sXFZWp22xerrJ6FbhTTFRtNt58PCFr5GKKWRiNJzh4W247hb535R4sy3wMY`
    },
    noparam () {
      this.form.mobile = ''
      this.form.code = ''
      this.form.smsCode = ''
      this.form.cardNo = ''
      this.form.uuid = ''
      this.getImg()
    },
    // openLoginDialogBox (val) {
    //   console.log(val, 'val')
    //   this.dialogVisible = val

    // },

    weixinLogin () {

      this.type = (this.type == 3) ? 2 : 3

    },

    getImg () {
      getCaptchaImg().then(res => {
        this.captchaData = "data:image/png;base64," + res.img
        this.form.uuid = res.uuid
      })
    },
    getSMS () {
      // if (!/^[1][35789][0-9]{9}$/.test(this.form.mobile)) {
      if (!/^[0-9]*$/.test(this.form.mobile)) {
        this.$message.error("請輸入正確手機號")
        return
      }
      if (!this.form.code) {
        this.$message.error("請輸入圖片驗證碼")
        return
      }

      if (this.text === "獲取驗證碼") {
        smsCode({
          //mobile: this.ac + this.form.mobile,
          mobile: this.form.mobile,
          uuid: this.form.uuid,
          code: this.form.code,
          scene: "LOGIN"
        }).then(res => {
          if (res.code == 500) {
            this.$message.error(res.msg)
            this.getImg()
            return
          }
          let num = 60
          this.timer = setInterval(() => {
            num--

            if (num === 0) {
              clearInterval(this.timer)
              this.timer = null
              this.text = `獲取驗證碼`
            }
            else {
              this.text = `重新獲取(${num}s)`
              // console.log(num,'num');
            }
          }, 1000)

          this.form.uuid = res.uuid
          // this.form.smsCode = res.smsCode
        })
      } else {
      }
    },
    onClick_1 () {
      if (!this.checked) {
        this.$message.warning("請先閱讀條款並同意勾選")
        return
      }
      if (!this.form.mobile) {
        this.$message.error("請輸入手機號")
        return
      }
      // if (!/^[1][35789][0-9]{9}$/.test(this.form.mobile)) {
      /*if (!/^[0-9]*$/.test(this.form.mobile)) {
        this.$message.error("請輸入正確手機號")
        return
      }*/
      if (!this.form.passWord) {
        this.$message.error("請輸入密碼")
        return
      }
      // if (!this.form.smsCode) {
      //   this.$message.error("請輸入驗證碼")
      //   return
      // }
     /* smsLogin({ ...this.form, mobile: this.ac + this.form.mobile }).then(
        res => {
          this.login(res)
        }
      )*/
      smsLogin({ ...this.form, mobile: this.form.mobile }).then(
        res => {
          this.login(res)
        }
      )
    },
    //微信登录
    // WXLogin (code) {
    //   // console.log(code, 'code')
    //   wxLogin({ code: code, cardNo: this.form.cardNo }).then(
    //     res => {
    //       console.log(res, 'res')
    //       this.login(res)
    //     }
    //   )
    // },
    // localStorage.cardNo ? localStorage.cardNo : ''


    login (res) {
      if (res.code === 200) {
        // localStorage.setItem("token", "Bearer " + res.token)
        // eventBus.$emit("getUserInfo")
        // this.$message.success("登録成功")
        // this.$router.replace({
        //   path: this.$route.query.forword ? this.$route.query.forword : "/"
        // })
        localStorage.setItem("token", "Bearer " + res.token)
        eventBus.$emit("getUserInfo")
        eventBus.$emit("doChangeloginVisible", false)
        this.noparam()
        this.$message.success("登録成功")
        if (this.$route.path == '/login') {
          this.$router.replace({
            path: this.$route.query.forword ? this.$route.query.forword : '/'
          })
        } else if (this.$route.path == '/search') {
          this.$bus.$emit("reloadSearch", true)
        } else {
          location.reload()
        }


        // eventBus.$emit("openBindMobile")


      } else {
        this.$message.error(res.msg)
      }
    },


  },
  // watch: {
  //   $route (to, from) {
  //     // console.log(to, from, 'tofrom')
  //     let isLogin = localStorage.getItem("token") ? true : false
  //     let code = this.$route.query.code
  //     if (code && !isLogin) {
  //       this.WXLogin(code)

  //     }
  //   }
  // }
  // watch: {
  //   'form.cardNo': {
  //     handler (newVal, oldVal) {
  //       localStorage.setItem('cardNo', newVal)
  //     },
  //     deep: true
  //   },
  //   bindchecked (newV, oldV) {
  //     if (!newV) {
  //       localStorage.setItem('cardNo', '')
  //       this.form.cardNo = ''
  //     }
  //   }


  // }
  beforeDestroy () {
    eventBus.$off("WeiLogin")
    eventBus.$off("noparam")
    eventBus.$off("dkLogin")
  }

}


</script>


<style lang="less" scoped>
.wxbc {
  font-size: 0.7rem;
  line-height: 0.7rem;
  padding-left: 0.7rem;
  font-family: FZShuSong-Z01T;
  font-weight: 400;
  color: #000000;
  width: 8rem;
  height: 2.4rem;
  background: url(/static/img/tishi.png) no-repeat;
  background-size: 100% 100%;
}
/deep/ .el-checkbox__label {
  color: #4473d0;
  font-size: 0.81rem;
  font-weight: 400;
  font-family: FZShuSong-Z01T;
  .bfore {
    color: #aaaaaa;
  }
}
/deep/ .el-checkbox__inner {
  border: 2px solid #4473d0;
}

.wrap1 {
  // width: 33rem;
  display: flex;
  background: #fff;
  box-shadow: 0px 9px 17px 0px rgba(188, 188, 188, 0.5);
  border-radius: 10px;
  padding: 1.5rem 5.5rem;
  > div {
    flex: 1;
    height: 100%;
  }

  .wrap2 {
    z-index: 10;
    height: 100%;
    border-radius: 29px;
    background-color: rgba(255, 255, 255, 1);
  }
  .layer1 {
    margin-bottom: 3.25rem;
  }
  .title {
    font-size: 1.56rem;

    font-weight: 400;
    color: #4473d0;
  }
  .ipt-margin {
    margin-bottom: 1.5rem;
  }
  /deep/ .el-input-group__append {
    img,
    button {
      color: #fff;
      background-color: #409eff;
      border-color: 1px solid #409eff;
      border-radius: 0;
      width: 112px;
      height: 38px;
      background-size: 100% 100% !important;
    }
  }
  .login {
    width: 17.88rem;
    height: 2.5rem;
    background: #4473d0;
    border-radius: 2rem;
    margin: 2rem auto;
    text-align: center;
    font-size: 1.2rem;
    font-family: FZShuSong-Z01T;
    font-weight: 400;
    color: #ffffff;
  }
  .checked {
    margin: 0 auto;
  }
}

/deep/.el-input-group__prepend {
  // padding-right: 0;
  .ac-ipt {
    width: 76px;
    input {
      font-size: 13px;
      color: #4473d0;
      height: 38px;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/logindialog.vue